import type { IconData } from '@stacksjs/iconify-core'

export const header6: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 4h4V1a1 1 0 1 1 2 0v8a1 1 0 1 1-2 0V6H2v3a1 1 0 1 1-2 0V1a1 1 0 1 1 2 0zm11.949 2.057c.43.44.651.999.651 1.64c0 .629-.228 1.18-.67 1.62c-.442.437-.99.663-1.613.663a2.2 2.2 0 0 1-1.649-.693c-.43-.45-.652-.985-.652-1.58q0-.337.1-.672c.063-.211.664-1.627.837-1.966q.377-.737 1.197-2.137l1.78.652l-.917 1.88c.249.113.733.386.936.593m-1.63.765a.85.85 0 0 0-.858.863a.85.85 0 0 0 .252.613a.865.865 0 0 0 1.48-.614a.84.84 0 0 0-.25-.611a.87.87 0 0 0-.623-.251z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default header6
